export default __webpack_public_path__ + "Src/Client/Tiles/MultiLinkTile/multiLinkTile.html";